import React from 'react'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from 'ag-grid-react'

export const CategoryWiseItemList = (props) => {
    return (
        <div className='record-insert'>
            <span className="text-blue text-[16px] font-semibold ">Select plant details</span>
            <div className='item-grp grid grid-cols-3 items-end gap-2.5 mt-[5px] mb-5'>
                <div className='input-grp col-span-2'>
                    <label>Select Plant</label>
                    <MultiSelectDropdown
                        drpIdentity="Select plant"
                        options={props.plantObjectCategory.plantList}
                        value={props.plantObjectCategory.idPlant ? props.plantObjectCategory.plantList.find(x => x.value === props.plantObjectCategory.idPlant) : 0}
                        onChange={(event) =>
                            props.handleChangeFroDropdown(event, "plantObjectCategoryPlantId")
                        }
                        className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                    />
                </div>
                <div className='input-grp'>
                    <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.viewRecords()}>View records</button>
                    {/* <button className="save-btn btns py-[10px] px-[20px] h-[40px]">View records</button> */}
                </div>
            </div>
            <span className="text-blue text-[16px] font-semibold ">Item list</span>
            <div className='record-table mt-[5px]' style={{ height: "calc(100vh - 260px)" }}>
                <div className="table-inner h-full">
                    <AgGridReact
                        rowData={props.plantObjectCategory.rowData}
                        columnDefs={props.plantObjectCategory.colDefs}
                        onCellClicked={props.handleCellClickItemList}
                    />
                </div>
            </div>
        </div>
    )
}
